import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Send from "@mui/icons-material/Send";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFlag } from "../../server/optimizely";
import { CeTextInput } from "../generic/components/form-fields/ce-text-field";
import type { CreateContentRequest } from "../multiformat/store/types";
import { CreateContentFileUpload } from "./create-content-file-upload";

export const ContentDescriptionTextField: FC<{ fileUpload: boolean }> = ({ fileUpload }) => {
  const { t } = useTranslation();
  const [mfai_file_upload] = useFlag("mfai_file_upload");

  const showFileUpload = fileUpload && mfai_file_upload;

  return (
    <Box sx={{ position: "relative", p: 0, m: 0 }}>
      <CeTextInput<CreateContentRequest>
        variant="outlined"
        name="q"
        label={t("Describe your content")}
        multiline
        fullWidth
        rows={showFileUpload ? 3 : 4}
        slotProps={
          showFileUpload
            ? {
                input: {
                  endAdornment: <CreateContentFileUpload />,
                  sx: {
                    position: "relative",
                    pb: "2.5rem",
                  },
                },
              }
            : undefined
        }
      />
      {showFileUpload && (
        <Stack sx={{ mt: 0, pt: 1 }} direction="row" gap={1}>
          <InfoOutlined fontSize="small" color="action" />
          <Typography variant="body2" color="text.primary">
            {t(
              "Consider entering around 1,000 characters or uploading a PDF or Word document for the best results",
            )}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export const ContentDescriptionTextFieldNew: FC<{ fileUpload: boolean }> = ({ fileUpload }) => {
  const { t } = useTranslation();
  const [mfai_file_upload] = useFlag("mfai_file_upload");

  const showFileUpload = fileUpload && mfai_file_upload;

  return (
    <Box sx={{ position: "relative", p: 0, m: 0, backgroundColor: "white", borderRadius: 2 }}>
      <CeTextInput<CreateContentRequest>
        variant="outlined"
        name="q"
        label={t("Describe what you want to create")}
        multiline
        fullWidth
        rows={showFileUpload ? 3 : 4}
        slotProps={{
          input: {
            endAdornment: (
              <>
                {showFileUpload && <CreateContentFileUpload />}
                <IconButton
                  data-analytics-id="create-content-generate"
                  data-testid="submit-button"
                  color="primary"
                  type="submit"
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                  }}
                >
                  <Send />
                </IconButton>
              </>
            ),
            sx: {
              position: "relative",
              pb: "2.5rem",
            },
          },
        }}
      />
    </Box>
  );
};
